import CV from "./cv";
import Psych from "./psych";
import Operators from "./operators";
import DocumentSearch from "./document";
import Gemms from "./gemms";
import Obesity from "./obesity";

export { CV, Psych, Operators, DocumentSearch, Gemms, Obesity };

export const metadataMap = {
    'CARDIO': CV,
    'PSYCH': Psych,
    'DOCUMENT': DocumentSearch,
    'GEMMS': Gemms,
    'OBESITY': Obesity,
    'CV': CV,
    'Psych': Psych,
    'DocumentSearch': DocumentSearch,
    'Gemms': Gemms,
    'Obesity': Obesity
};